export const formatPhoneNumber = (phoneNumber: number | string) => {
  const phoneText = phoneNumber?.toString();
  if (!phoneText) return;

  const countryCode = phoneText.slice(0, 3);
  const areaCode = phoneText.slice(3, 6);
  const rest = phoneText.slice(6);
  return `(${countryCode}) ${areaCode}-${rest}`;
};
